export default [
    {
        name: 'environmentMapTextures',
        type: 'cubeTexture',
        path: [
            '/textures/environmentMaps/0/px.png',
            '/textures/environmentMaps/0/nx.png',
            '/textures/environmentMaps/0/py.png',
            '/textures/environmentMaps/0/ny.png',
            '/textures/environmentMaps/0/pz.png',
            '/textures/environmentMaps/0/nz.png'
        ]
    },
    {
        name: 'carModel',
        type: 'gltfModel',
        path: '/models/test/CarTest27.png'
    },
]